



































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import {getLodop} from '../../lib/lodop.js'

@Component({
  components:{}
})
export default class extends AbpBase{
    @Prop({type:String,default:''}) printDom:String;
    @Prop({type:String,default:''}) title:String;
    @Prop({type:Array,default:[]}) columns:any;
    @Prop({type:Array,default:[]}) data:any;

    hospitalName = '平顶山康莱尔血液透析中心'

    //是否需要合并
    childrenCont = 0
    childrenList = []
    keys = []
    created() {


        // let outerChildren = this.columns.filter((item:any)=>{return !!item.children});
        // let outerChildren2 = outerChildren.map((item:any)=>{return item.children})
        // outerChildren2.forEach((item:any)=>{
        //     this.childrenList.push(...item)
        // })
        this.getChildrenlist(this.columns,this.childrenList)
        console.log(this.childrenList)



        this.columns.forEach((item:any)=>{
            if(!item.children){
                this.keys.push(item.key)
            }else{
                this.getChildrenKey(item.children,this.keys)
            }
        })
        this.getheardRow()
        this.$nextTick(()=>{
            this.printPdf()
        })
        console.log(this.heardRow)
    }
    heardRow = 0
    getheardRow(){
        let vm = this;
        getCrow(this.columns,vm.heardRow)
        function getCrow(list,row) {
            list.forEach(item => {
                if(item.children){
                    vm.heardRow+=1
                    console.log(vm.heardRow)
                    getCrow(item.children,vm.heardRow)
                }
            });
        }
    }
    heardCol(columns){
        console.log(columns)
        let col = 0;
        getCCol(columns,col)
        function getCCol(list,row) {
            list.forEach(item => {
                if(!item.children){
                    col+=1
                }else{
                    getCCol(item.children,col)
                }
            });
        }
        return col
    }
    //获取每个层级的children
    getChildrenlist(list,arr){
        let children = []
        list.forEach((item:any)=>{
            if(item.children){
                children.push(...item.children)
            }
        })
        if(children.length!=0){
            arr.push(children)
            console.log(arr)
        }
        list.forEach((item:any)=>{
            if(item.children){
                this.getChildrenlist(item.children,arr)
            }
        })
        
    }


    getChildrenKey(list,keys){
        list.forEach(item => {
            if(!item.children){
                keys.push(item.key)
            }else{
                this.getChildrenKey(item.children,keys)
            }
        });
    }

    printPdf(){
            try {
                let  LODOP = getLodop();
                //判断打印是否初始化完成
                if (LODOP) {
                    let strBodyStyle =
                        `<style>
                            td{text-align: center;min-height: 40px;font-size: 11px;}
                            </style>`;
                    let strFormHtml = strBodyStyle + (this.$refs.print as any).innerHTML;
                    LODOP.SET_PRINT_STYLE("FontSize", 11);
                    LODOP.SET_PRINT_STYLE("Bold", 1);
                    LODOP.ADD_PRINT_TEXT(0, 0, 0, 0, "打印页面部分内容");
                    //增加超文本打印项，设定该打印项在纸张内的位置和区域大小，实现超文本控制打印。
                    LODOP.ADD_PRINT_HTM(34, 34, "RightMargin:0.9cm", "BottomMargin:9mm", strFormHtml);
                    LODOP.SET_PRINT_PAGESIZE(2, 0, 0, this.size); //规定纸张大小；使用A4纸。
                    LODOP.SET_SHOW_MODE("LANDSCAPE_DEFROTATED", 1);//横向时的正向显示
                    LODOP.PREVIEW();
                }
                //预览中|打印中，返回回调函数
                this.$emit('on-finish')
            } catch(err) {
                console.log(err)
            }
        }

    //获取当日时间
    get getdate(){
        //当日时间
        let date = new Date();
        let seperator1 = "-";
        let year = date.getFullYear();
        let month:any = date.getMonth() + 1;
        let strDate:any = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        return  year + seperator1 + month + seperator1 + strDate;
    }
    //登陆人
    get userName(){
        return this.$store.state.session.user?this.$store.state.session.user.name:''
    }
}
